export default __webpack_public_path__ + "static/media/offline21.ae405752.png";